module.exports = __webpack_public_path__ + "static/media/sac_state_logo.cc1dccb5.png";